/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    IncidentForSort,
    RollingStockInformationForSort,
    RollingStockInformationForSortWithWeight
} from '../models/rollingStockInformation';

const INCIDENT_WEIGHT_BY_PRIORITY_LABEL: Record<string, number> = Object.freeze({
	DI: 10,
	GR: 200,
	PB: 20,
	PRIORITY_DI: 3000,
	PRIORITY_GR: 4000,
} as const);

export const addIncidentsWeight = <T extends RollingStockInformationForSort>(
	updateInformation: T
): RollingStockInformationForSortWithWeight => ({
	...updateInformation,
	incidentsWeight: updateInformation.incidents.reduce(
		(totalWeight, incident) => totalWeight + getWeightByIncidentPriority(incident),
		0
	),
});

const getWeightByIncidentPriority = <T extends IncidentForSort>(incident: T) => {
	const priorityLabel = incident.isPriority ? `PRIORITY_${incident.code}` : incident.code;

	return INCIDENT_WEIGHT_BY_PRIORITY_LABEL[priorityLabel] ?? 0;
};

export const sortByPriority = <T extends RollingStockInformationForSortWithWeight>(
	a: T,
	b: T
) => {
	if (a.isUsed !== b.isUsed) {
		return Number(b.isUsed) - Number(a.isUsed);
	}

	if (a.incidentsWeight !== b.incidentsWeight) {
		return b.incidentsWeight - a.incidentsWeight;
	}

	if (!!a.lastNPUpdate !== !!b.lastNPUpdate) {
		return a.lastNPUpdate ? -1 : 1;
	}

	if (a.lastNPUpdate && b.lastNPUpdate) {
		return a.lastNPUpdate.getTime() - b.lastNPUpdate.getTime();
	}

	return a.trainCode.localeCompare(b.trainCode);
};
